import isMobile from '../../utils/isMobile';

class Slideshow {
  constructor(elem) {
		this.elem = elem[0];
		
		this.shouldAutoplay = this.elem.dataset['autoplay'] === 'True' ? true : false;
		this.interval = null

    this.list = this.elem.querySelector('.slideshow__list');
    this.nextButton = this.elem.querySelector('.next')
        
    this.nextButton.addEventListener('click', () => this.onNextClick(true))
    window.addEventListener('resize', this.setDims.bind(this))
    
    this.swipeStartX = 0;
    this.swipeEndX = 0;
    this.init();
  }

  init() {
    this.list.children[0].classList.add('current');
    this.setDims();
    const children = Array.prototype.slice.call(this.list.children)
    children.forEach(child => {
      this.addSwipeListeners(child)
		})

		if(this.shouldAutoplay) {
			this.autoplay()
		}
	}
	
  setDims() {
    const children = Array.prototype.slice.call(this.list.children)
    
    setTimeout(() => {
      this.elem.style.height = Math.max(...children.map(item => item.clientHeight)) + 'px';
      const imgHeight = this.list.children[0].querySelector('.slideshow-image').clientHeight
  
      this.nextButton.style.top = imgHeight / 2 + 'px'
    }, isMobile() ? 500 : 0);
  }

  addSwipeListeners(elem) {
    elem.addEventListener('touchstart', this.handleSwipeStart.bind(this), false)
    elem.addEventListener('touchend', this.handleSwipeEnd.bind(this), false)
  }

  cloneListItem(item) {
    const clone = item.cloneNode(true)
    this.addSwipeListeners(clone)
    return clone
  }

  handleSwipeStart() {
     this.swipeStartX = event.changedTouches[0].screenX
  }

  handleSwipeEnd() {
    this.swipeEndX = event.changedTouches[0].screenX

    if(this.swipeStartX + 25 < this.swipeEndX) {
      this.onNextClick(true)
    }
	}
	
	autoplay() {
		setTimeout(() => {
			this.onNextClick(true);
		}, 2000);
	}
 
  onNextClick(userInteraction = false) {
    const currentImg = this.list.querySelector('.current')
    const nextImg = this.list.querySelector('.current + li')
    const clone = this.cloneListItem(currentImg)
    clone.className = ''
    this.list.appendChild(clone)
    currentImg.className = 'out'
		nextImg.classList.add('current')

		if (userInteraction && this.shouldAutoplay) {
			clearInterval(this.interval)

			this.interval = setInterval(() => {
				this.onNextClick();
			}, 2000);
		}

    setTimeout(() => {
      this.list.removeChild(this.list.children[0]);
    }, 500);
  }
}

export default Slideshow;
